import { render, staticRenderFns } from "./TheNavbarToolsPanelPreciseDigitizing.vue?vue&type=template&id=645061e5&scoped=true&"
import script from "./TheNavbarToolsPanelPreciseDigitizing.vue?vue&type=script&lang=js&"
export * from "./TheNavbarToolsPanelPreciseDigitizing.vue?vue&type=script&lang=js&"
import style0 from "./TheNavbarToolsPanelPreciseDigitizing.vue?vue&type=style&index=0&id=645061e5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645061e5",
  null
  
)

export default component.exports